<template>
  <mt-swipe v-bind:style="getBannerStyle" :showIndicators="isShowIndicators" class="indexbanners">
    <mt-swipe-item v-for="(item, index) in items" :key="index">
      <img :style="getBannerStyle" v-lazy="item.adv_code" v-if='item.adv_code' @click="goAdUrl(item)">
      <!--<img :style="getBannerStyle" src="../../../assets/image/home/default_image_banner.png" v-else>-->
    </mt-swipe-item>
  </mt-swipe>
</template>

<script>
export default {
  name: 'IndexBanner',
  data () { 	
    return {
    }
  },
  props: ['items'],
  created: function(){
  	
  },
  computed: {
    getBannerStyle: function () {
      const { width } = window.screen
      let itemWidth = width
      let itemHeight = width/2
      
      return {
        width: 100 + '%',
        height: itemHeight + 'px',
        'max-height':10+'rem'
      }
    },
    isShowIndicators () {
      if (this.items && this.items.length > 1) {
        return true
      }
      return false
    }
  },
  methods: { 	
    goAdUrl (item) {
    	//暂时隐藏，都跳转导云展
    	this.$router.push({ 'name': 'HomeLiveIndex' })
//    switch (item.adv_type) {
//      case 'goods':
//        this.$router.push({ name: 'HomeGoodsdetail', query: { goods_id: item.adv_typedate } })
//        break
//      case 'store':
//        this.$router.push({ name: 'HomeStoredetail', query: { id: item.adv_typedate } })
//        break
//      case 'article':
//        this.$router.push({ name: 'HomeArticledetail', query: { article_id: item.adv_typedate } })
//        break
//      case 'url':
//        window.location.href=item.adv_typedate
//        break  
//    }
    }
  }
}
</script>

<style>
	/*.indexbanners{margin-top: 1rem;}*/
.mint-swipe-indicator{width: 12px;height: 12px;background-color: #fff;opacity: 1;margin-top: 4px;float: left;}
body .mint-swipe{overflow: inherit;}
body .mint-swipe-items-wrap{border-radius: 0px;}
.indexbanners .mint-swipe-indicators .is-active{background-color: #ffff00;opacity: 1;}
body .indexbanners .mint-swipe-indicators{bottom: rem;}

</style>
